import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';

const BrownoutAnxiety: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.BrownoutAnxiety');
    useCardsShowHook('#D3A-BrownoutAnxiety .sub-img', '#D3A-BrownoutAnxiety', true);
    return (
        <section className={`${styles.BrownoutAnxiety} GtmModuleData-section range9`} id="D3A-BrownoutAnxiety" data-section-id={'D3A-BrownoutAnxiety'}>
            <div className="content-wrap">
                <div className="title">{t('title')}</div>
                <div className="content">
                    <div className="sub-title">{t('subtitle')}</div>
                    <div className="sub-img">
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1763364595442/anxiety-pc-1.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1763364595238/anxiety-m-1.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1763364595238/anxiety-m-1.png"
                        ></EcoImg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BrownoutAnxiety;
